import React from "react";
import ReactNumeric from "../components/ReactNumeric/ReactNumeric";

export const JedaiCantidades = ({ field, form, className, ...props }) => (
    <ReactNumeric
        field={field}
        form={form}
        {...props}
        className={"text-right " + className}
        valuex={field.value}
        name={field.name}
    />
);

export const JedaiCantidadesDias = ({ field, form, className, dp = 0, ...props }) => (
    <ReactNumeric
        field={field}
        form={form}
        {...props}
        className={"text-right " + className}
        valuex={field.value}
        name={field.name}
        decimalPlaces={dp}
    />
);
